const messages = {
    accountBox: {
        title: "Panou de control",
        description: "Urmărește rapid promoțiile și punctele tale.",
        button: "DESCHIDE PANOUL DE CONTROL",
    },
};

export default {
    messages,
};
